import { render } from "./Unsubribe.vue?vue&type=template&id=4b0aaa34"
import script from "./Unsubribe.vue?vue&type=script&lang=js"
export * from "./Unsubribe.vue?vue&type=script&lang=js"

import "./Unsubribe.vue?vue&type=style&index=0&id=4b0aaa34&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__